import { StickerGroupType } from "../../containers/popup/popup-sticker-group";
import { FileSend } from "../../libs/fileHandler";
import { RoomMessage } from "../../proto/Global_pb";
import { InfoConfigResponse } from "../../proto/InfoConfig_pb";
import { ChatSettingsStorageType } from "../../constants/localstorage";

export const SET_ATTACHMENT = "SET_ATTACHMENT";
export const SET_EDIT_ID = "SET_EDIT_ID";
export const SET_MESSENGER_PLAYER_AUDIO = "SET_MESSENGER_PLAYER_AUDIO";
export const SET_MESSENGER_THEME = "SET_MESSENGER_THEME";
export const SET_MESSENGER_INFO_CONFIG = "SET_MESSENGER_INFO_CONFIG";
export const ADD_STICKER_GROUP = "ADD_STICKER_GROUP";
export const EDIT_IS_IN_USER_LIST_STICKER_GROUP = "EDIT_IS_IN_USER_LIST_STICKER_GROUP";
export const SET_CRAPPER_VISIBILITY = "SET_CRAPPER_VISIBILITY";
export const ADD_CHAT_SETTINGS = "ADD_CHAT_SETTINGS";
export const SET_CURRENT_TABS_ASIDE = "SET_CURRENT_TABS_ASIDE";
export const SET_UPDATE_AVAILABLE = "SET_UPDATE_AVAILABLE";
export const SET_SCROLL_INITIALIZED = "SET_SCROLL_INITIALIZED";
export const SET_MULTI_SESSION = "SET_MULTI_SESSION";
// export const SET_MESSENGER_TEXT_TO_VOICE_TYPE = "SET_MESSENGER_TEXT_TO_VOICE_TYPE";

export type MessengerAttachmentType = Array<FileSend> | undefined;
export type MessengerReplyIdType = RoomMessage.AsObject["messageId"] | undefined;
export type MessengerEditIdType = RoomMessage.AsObject["messageId"] | undefined;
export type PlayerAudioMessageIdType = {
  messageId: RoomMessage.AsObject["messageId"] | undefined;
  status: string | undefined;
};
// export type TextToVoiceMessage = boolean;
export type MessengerInfoConfigType = InfoConfigResponse.AsObject | undefined;
export type MessengerAsideTabsType = InfoConfigResponse.AsObject["defaulttab"];
export enum MessengerThemeType {
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export enum MessengerThemeLayoutType {
  WIDE = "WIDE",
  BOXED = "BOXED",
}

export type ImageCropperType = {
  visibility: boolean;
  dragOption: Array<File>;
  preview: string;
  isImage: boolean;
};

export type stickerGroupsType = {
  [groupId in StickerGroupType["categoryId"]]: StickerGroupType;
};

export type MessengerStateType = {
  messengerAttachment: MessengerAttachmentType;
  messengerEditId: MessengerEditIdType;
  playerAudioMessageId: PlayerAudioMessageIdType;
  messengerTheme: MessengerThemeType;
  messengerInfoConfig: MessengerInfoConfigType;
  stickerGroups: stickerGroupsType;
  imageCropper: ImageCropperType;
  chatSettings: ChatSettingsStorageType;
  asideTabs: MessengerAsideTabsType;
  updateAvailable: boolean;
  scrollInitialized: boolean;
  multiSession: boolean;
};

export type SetMessengerAsideTabsType = {
  type: typeof SET_CURRENT_TABS_ASIDE;
  payload: MessengerAsideTabsType;
};

export type SetMessengerAttachmentActionType = {
  type: typeof SET_ATTACHMENT;
  payload: MessengerAttachmentType;
};

export type SetMessengerEditIdActionType = {
  type: typeof SET_EDIT_ID;
  payload: MessengerEditIdType;
};

export type SetMessengerPlayerAudioActionType = {
  type: typeof SET_MESSENGER_PLAYER_AUDIO;
  payload: PlayerAudioMessageIdType;
};

// export type setMEssaengerTextToVoiceType = {
//   type: typeof SET_MESSENGER_TEXT_TO_VOICE_TYPE;
//   payload: TextToVoiceMessage;
// };
export type SetMessengerThemeActionType = {
  type: typeof SET_MESSENGER_THEME;
  payload: MessengerThemeType;
};
export type SetMessengerInfoConfigActionType = {
  type: typeof SET_MESSENGER_INFO_CONFIG;
  payload: MessengerInfoConfigType;
};
export type AddStickerGroupActionType = {
  type: typeof ADD_STICKER_GROUP;
  payload: StickerGroupType[];
};
export type EditIsInUserListStickerGroup = {
  type: typeof EDIT_IS_IN_USER_LIST_STICKER_GROUP;
  payload: StickerGroupType["categoryId"];
};
export type SetCrapperVisibility = {
  type: typeof SET_CRAPPER_VISIBILITY;
  payload: ImageCropperType;
};
export type ChatSettingsType = {
  type: typeof ADD_CHAT_SETTINGS;
  payload: Partial<ChatSettingsStorageType>;
};
export type SetUpdateAvailable = {
  type: typeof SET_UPDATE_AVAILABLE;
  payload: boolean;
};
export type SetScrollInitialized = {
  type: typeof SET_SCROLL_INITIALIZED;
  payload: boolean;
};

export type SetMultiSession = {
  type: typeof SET_MULTI_SESSION;
  payload: boolean;
};

export type MessengerActionTypes =
  | SetMessengerAttachmentActionType
  | SetMessengerEditIdActionType
  | SetMessengerPlayerAudioActionType
  | SetMessengerThemeActionType
  | SetMessengerInfoConfigActionType
  | AddStickerGroupActionType
  | SetCrapperVisibility
  | EditIsInUserListStickerGroup
  | ChatSettingsType
  | SetMessengerAsideTabsType
  | SetUpdateAvailable
  | SetScrollInitialized
  | SetMultiSession;
